import { createStore, applyMiddleware, Middleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '@app/store/reducers';

let middleware: Middleware[] = [thunk];

// TODO: change to global env instead process.env.NODE_ENV
if (process.env.NODE_ENV !== 'production') {
    const { createLogger } = require('redux-logger');
    middleware = [...middleware, createLogger()];
}



export const store = createStore(
    rootReducer,
    applyMiddleware(...middleware)
);
